import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import FaqComponents from "../components/common/faq";

const faqs = [
  {
    question: "What is Mobile App Development?",
    answer: `<p>Mobile app development involves creating software applications specifically for mobile devices. It encompasses the design, development, and deployment of apps that run on iOS, Android, or cross-platform environments, focusing on optimizing performance and user experience.</p>`,
  },
  {
    question: "What are the Best Practices in Mobile App Development?",
    answer: `<p>Best practices include using agile methodologies, implementing secure coding standards, conducting thorough testing, and optimizing for performance. Prioritizing UX/UI design, integrating analytics, and ensuring scalability are also critical. Regular updates and iterative improvements are essential for maintaining app relevance and performance.</p>`,
  },
  {
    question: "What Platforms Your Mobile Application Development Agency Use?",
    answer: `<p>Common platforms include iOS, Android, and cross-platform frameworks like Flutter and React Native. Each platform has specific tools and languages; iOS uses Swift or Objective-C, Android uses Kotlin or Java, and cross-platform frameworks use a single codebase to deploy on multiple platforms.
</p>`,
  },
  {
    question: "How Long Does It Take to Develop an App?",
    answer: `<p>App development timelines vary based on complexity. Simple apps may take 3-6 months, while more complex apps with advanced features can take 9-12 months or longer. Detailed planning, design iterations, and thorough testing are critical to the development process.</p>`,
  },
  {
    question: "How Much Does It Cost to Hire Someone to Build a Mobile App?",
    answer: `<p>The cost of mobile app development services ranges from $30,000 to $300,000, depending on the app's complexity, features, and platform. Factors influencing cost include development hours, design complexity, backend infrastructure, and ongoing maintenance.</p>
    <p><b>Disclaimer:</b> Costs may vary based on specific project requirements and complexity.</p>`,
  },
  {
    question:
      "What is the Difference Between Native and Cross-Platform Development?",
    answer: `<p>Native development uses platform-specific languages (Swift for iOS, Kotlin for Android) and offers superior performance and access to device features. Cross-platform development uses frameworks like Flutter or React Native to deploy a single codebase on multiple platforms, reducing development time but with potential trade-offs in performance.</p>`,
  },
  {
    question: "Does Tekrevol Offer NDAs for App Development Projects?",
    answer: `<p>Yes, our app development company offers Non-Disclosure Agreements (NDAs) to protect your intellectual property and ensure confidentiality throughout the development process.</p>`,
  },
  {
    question: "Does Tekrevol Offer Ongoing App Maintenance Services?",
    answer: `<p>Yes, we provide ongoing maintenance services, including bug fixes, updates, and feature enhancements. Our mobile app development agency ensures your app remains secure, up-to-date, and optimized for performance.</p>`,
  },
  {
    question: "Why Choose Tekrevol for Mobile App Development Services?",
    answer: `<p>Tekrevol combines technical expertise with a focus on innovation and scalability. Our mobile app development company leverages the latest technologies, rigorous testing, and a client-focused approach to deliver apps that perform exceptionally and drive business growth.</p>`,
  },
];

function FaqLocation(props) {
  return (
    <div className="faq_loc p-100 tekrevol_dark_bg">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>Mobile App Development FAQs</h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="services_faqs"
          >
            <FaqComponents faqs={faqs} />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
